export default [
  {
    name: "Ana Popescu",
    text:
      "Cel mai bun ITP din Ploiesti! Cei mai profesionisti oameni si cele mai noi aparaturi. Recomand",
  },
  {
    name: "Mircea Eliade",
    text:
      "Cel mai bun ITP din Ploiesti! Cei mai profesionisti oameni si cele mai noi aparaturi. Recomand",
  },
  {
    name: "Ciprian Marica",
    text:
      "Cel mai bun ITP din Ploiesti! Cei mai profesionisti oameni si cele mai noi aparaturi. Recomand",
  },
  {
    name: "Elena Udrea",
    text:
      "Cel mai bun ITP din Ploiesti! Cei mai profesionisti oameni si cele mai noi aparaturi. Recomand",
  },
]
